var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pages"},[_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next","page-size":_vm.size,"total":_vm.total,"current-page":_vm.mypage},on:{"update:currentPage":function($event){_vm.mypage=$event},"update:current-page":function($event){_vm.mypage=$event},"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }